<template>
    <div class="overlay overlay--pane">

        <div class="overlay__holder">

            <div class="overlay__title">
                <strong v-if="!showKnobs">Add new gear</strong>
                <strong v-if="showKnobs">Add knobs to {{ newGear.brand }} {{ newGear.title }}</strong>
                <div class="overlay__close" @click="close()">&times;</div>
            </div>

            <div class="overlay__content">

                <div v-if="!showKnobs">
                    <form>

                        <!-- TODO: make required -->
                        <div class="form-group">
                            <label>Brand name<span class="form-group-req" /></label>
                            <input required placeholder="Pedal brand" type="text" v-model="newGear.brand"/>
                            <span class="form-group-help">Examples: MXR, Boss, Fender, ...</span>
                        </div>
                        <div class="form-group">
                            <label>Gear name<span class="form-group-req" /></label>
                            <input required placeholder="Gear name" type="text" v-model="newGear.title"/>
                            <span class="form-group-help">Examples: Tiny Terror, Twin Reverb, Les Paul, ...</span>
                        </div>
                        <div class="form-group">
                            <label>Website url<span class="form-group-req" /></label>
                            <input required placeholder="Website url" type="text" v-model="newGear.url" />
                            <span class="form-group-help">This is to verify the pedal</span>
                        </div>

                        <div class="form-group">
                            <label>Image URL</label>
                            <input placeholder="Image url" type="text" v-model="newGear.image" />
                            <span class="form-group-help">Copy the image address of the internet</span>
                        </div>
                        
                        <div class="form-group">
                            <label>Gear type <span class="form-group-req" /></label>
                            <select required v-model="newGear.type">
                                <option value="pedal">Pedal</option>
                                <option value="amp">Amp</option>
                                <option value="cabinet">Cabinet</option>
                                <option value="instrument">Instrument</option>
                                <option value="other">Other</option>
                            </select>
                        </div>

                        <span v-if="error" class="color--red">Please fill in the required fields</span>

                    </form>

                </div>

                <div v-if="showKnobs">
                    <!-- KNOBS -->
                    <draggable v-model="newGear.knobs">
                        <div class="form__knobs__holder" v-for="(knob, knobIndex) in newGear.knobs" :key="knob.id">

                            <div class="form__knobs__title">
                                <i class="handle las la-grip-lines"></i>
                                <input type="text" v-model="knob.title" placeholder="Knobtitle (Volume, Gain, ...)" />
                                <button v-b-tooltip.hover title="Delete knob" class="button button--icon button--delete" @click="removeKnob(knobIndex)"><i class="las la-trash-alt"></i></button>
                            </div>
                            <ul class="form__knobs">
                                <li class="form__knobs__item" v-b-tooltip.hover title="Turning knob" :class="{ 'form__knobs__item--active' : (newGear.knobs[knobIndex].type === 'knob')}">
                                    <knob knob-preview="knob"></knob>
                                    <input type="radio" :name="'type['+knobIndex+']'" v-model="newGear.knobs[knobIndex].type" value="knob">
                                </li>
                                <li class="form__knobs__item" v-b-tooltip.hover title="Slider, like an equalizer" :class="{ 'form__knobs__item--active' : (newGear.knobs[knobIndex].type === 'slider')}">
                                    <knob knob-preview="slider"></knob>
                                    <input type="radio" :name="'type['+knobIndex+']'" v-model="newGear.knobs[knobIndex].type" value="slider">
                                </li>
                                <li class="form__knobs__item" v-b-tooltip.hover title="Multiple options" :class="{ 'form__knobs__item--active' : (newGear.knobs[knobIndex].type === 'options')}">
                                    <knob knob-preview="options"></knob>
                                    <input type="radio" :name="'type['+knobIndex+']'" v-model="newGear.knobs[knobIndex].type" value="options">
                                </li>
                                <li class="form__knobs__item" v-b-tooltip.hover title="On or off switch" :class="{ 'form__knobs__item--active' : (newGear.knobs[knobIndex].type === 'switch')}">
                                    <knob knob-preview="switch"></knob>
                                    <input type="radio" :name="'type['+knobIndex+']'" v-model="newGear.knobs[knobIndex].type" value="switch">
                                </li>
                            </ul>
                            <div  class="form__knobs__item__options" v-if="knob.type === 'options'">
                                <draggable handle=".handle" v-model="knob.options">
                                    <div v-for="(option, optionIndex) in knob.options" :key="optionIndex" class="form__knobs__item__options__item">
                                        <i class="handle las la-grip-lines"></i>
                                        <input type="text" v-model="knob.options[optionIndex]" placeholder="Add an option" />
                                        <button v-b-tooltip.hover title="Delete option" class="button button--icon button--delete" @click="removeKnobOption(knobIndex, optionIndex)"><i class="las la-times"></i></button>
                                    </div>
                                </draggable>
                                <div class="form__knobs__item__options__item" @click="addKnobOption(knobIndex)">
                                    <i class="handle las la-plus"></i>
                                    <span class="form__knobs__item__options__item--add">Add option</span>
                                </div>
                            </div>
                        </div>
                        <button class="button button--ghost w-100" @click="addKnob()">Add a knob</button>
                    </draggable>

                </div>

            </div>

            <div class="overlay__footer">
                <button class="button" v-if="!showKnobs" @click="validate()">Next step</button>
                <button class="button button--ghost" v-if="showKnobs" @click="showKnobs = false">Back</button>
                <button class="button" v-if="showKnobs" @click="addGear()">Submit gear</button>
            </div>

        </div>
        
    </div>
</template>

<script>
import Knob from './Knob.vue';
import draggable from 'vuedraggable'
import { mapState } from 'vuex'
export default {
    data() {
        return {
            error: false,
            showKnobs: false,
            newGear: {
                knobs: [{
                    id: this.$uuid.v4(),
                    title: null,
                    type: null,
                    options: []
                }],
                type: "pedal_guitar"
            }
        }
    },
    components: { draggable, Knob },
    computed: {
        ...mapState(['currentUser']),
    },
    methods: {
        close: function(){
            this.$emit('close')
        },

        validate: function() {
            this.error = false
            if(!this.newGear.brand) {
                this.error = true;
                return false
            }
            if(!this.newGear.title) {
                this.error = true;
                return false
            }
            if(!this.newGear.url) {
                this.error = true;
                return false
            }
            this.showKnobs = true
        },

        addGear: function() {
            this.$store.dispatch('addGear', this.newGear)
            this.newGear = {}
            this.$emit('close')
        },

        addKnobOption: function(index) {
            this.newGear.knobs[index].options.push(null);
        },

        addKnob: function(){
            this.newGear.knobs.push({
                id: this.$uuid.v4(),
                title: null,
                type: null,
                options: []
            })
        },

        removeKnob: function(index){
            this.newGear.knobs.splice(index, 1)
        },

        removeKnobOption: function(knob,index){
            this.newGear.knobs[knob].options.splice(index, 1)
        },
    },
    created() {

    }
}
</script>